import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { SessionInterface } from '../../store/mine_craft/sessionsSlice';
import { uniq } from "../../helpers/ArrayHelpers";
import { deviceEntity, devicesEntity } from "./devicesActions";
import { DeviceInterface } from "../../store/mine_craft/devicesSlice";
import { userEntity, usersEntity } from "./usersActions";
import { UserInterface } from "../../store/mine_craft/usersSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.sessionPath(value.id)
  };
}

export const sessionsEntity = new schema.Entity(
  'sessions',
  {
    device: devicesEntity,
    user: usersEntity,
  },
  {
    processStrategy
  }
);

export const sessionEntity = new schema.Entity(
  'session',
  {
    device: deviceEntity,
    user: userEntity,
  },
  {
    processStrategy
  }
);


const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      device: { [key: string]: DeviceInterface };
      user:   { [key: string]: UserInterface };
      session: SessionInterface;
    }
  >(response.data.session, sessionEntity);
  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized  = normalize<
    any,
    {
      devices:  { [key: string]: DeviceInterface };
      users:    { [key: string]: UserInterface };
      sessions: { [key: string]: SessionInterface };
    }
  >(response.data.sessions, [sessionsEntity]);

  return {
    devices:  normalized.entities?.devices || {},
    users:    normalized.entities?.users || {},
    sessions: normalized.entities?.sessions || {},
    ids: uniq(normalized.result),
    count: response.data.meta?.total_count
  };
}

export const fetchSessions = createAsyncThunk(
  'sessions/fetchSessions',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get('/onesky/sessions', { params })
    return normalizeCollection(response);
  }
);

export const fetchSession = createAsyncThunk(
  'sessions/fetchSession',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/sessions/${id}`);
    return normalizeInstance(response);
  }
);

export const updateSession = createAsyncThunk(
  'sessions/updateSession',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/sessions/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
